import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { SharedModule } from "@shared";

import { LayoutDefaultComponent } from "./default/default.component";
import { HeaderFullScreenComponent } from "./default/header/components/fullscreen.component";
import { HeaderI18nComponent } from "./default/header/components/i18n.component";
import { HeaderIconComponent } from "./default/header/components/icon.component";
import { HeaderNotifyComponent } from "./default/header/components/notify.component";
import { HeaderStorageComponent } from "./default/header/components/storage.component";
import { HeaderTaskComponent } from "./default/header/components/task.component";
import { HeaderUserComponent } from "./default/header/components/user.component";
import { HeaderComponent } from "./default/header/header.component";
import { SidebarComponent } from "./default/sidebar/sidebar.component";
import { LayoutFullScreenComponent } from "./fullscreen/fullscreen.component";

import { SettingDrawerItemComponent } from "./default/setting-drawer/setting-drawer-item.component";
import { SettingDrawerComponent } from "./default/setting-drawer/setting-drawer.component";
// import { LayoutThemeBtnComponent } from "./default/theme-btn/theme-btn.component";
import { VerificationHeaderComponent } from "./nav/verification/verification-header/verification-header.component";
import { ProvisionHeaderComponent } from "./nav/provision/provision-header/provision-header.component";
import { SharingComponentComponent } from './default/sharing-component/sharing-component.component';
import { SharingHeaderComponent } from './nav/sharing/sharing-header/sharing-header.component';
// import { TempHeaderComponent } from './nav/temp-header/temp-header.component';

const SETTINGDRAWER = [SettingDrawerComponent, SettingDrawerItemComponent];
const COMPONENTS = [
  LayoutDefaultComponent,
  LayoutFullScreenComponent,
  HeaderComponent,
  SidebarComponent,
  ...SETTINGDRAWER,
    // LayoutThemeBtnComponent,
];

const HEADERCOMPONENTS = [
  HeaderNotifyComponent,
  HeaderTaskComponent,
  HeaderIconComponent,
  HeaderFullScreenComponent,
  HeaderI18nComponent,
  HeaderStorageComponent,
  HeaderUserComponent,
];

// import { WalletComponent } from "./default/wallet/wallet.component";
// const WALLETCOMPONENT = [WalletComponent];

@NgModule({
  imports: [SharedModule],
  declarations: [
    ...COMPONENTS,
    ...HEADERCOMPONENTS,
    VerificationHeaderComponent,
    ProvisionHeaderComponent,
    SharingComponentComponent,
    SharingHeaderComponent,
    // TempHeaderComponent,
  ],
  exports: [...COMPONENTS],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LayoutModule {}
